import React from "react";
// @jsx jsx
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { jsx, Styled } from "theme-ui";
import classes from "./Tape.module.scss";

const Tape: React.SFC<{}> = () => {
  const imgStyle = {
    margin: ["auto", "32px 0"],
    width: ["calc(100%)", "calc(100% + 55px)"],
    height: ["4vh", "unset"],
    backgroundRepeatY: "no-repeat",
    backgroundRepeat: "space no-repeat",
  };
  return (
    <div
      sx={{
        backgroundColor: "secondary",
        overflowX: "hidden",
        display: "flex",
        width: "100vw",
        height: [60, 112],
      }}
    >
      <div sx={{ ...imgStyle, ml: [-25, -55] }} className={classes.bgRepeat} />
    </div>
  );
};

export default Tape;
